module.exports = "/_next/static/images/ba88aecbbc0fca87cd46d767068c38d8-roxinho-scene-card-with-phone-xs@1x.jpg.webp";